export const PageNameConstant = {
  fleetList: "Current Fleet Details",
  replacementSchedule: "Strategic Replacement Plan",
  maintenanceAnalysis: "Maintenance & Repair Cost Comparison",
  fuelAnalysis: "Fuel Economy Comparison",
  fundingNewVehicle: "Recommended Acquisition Strategy",
  analysisResult: "Suggested 5-Year Plan & Cost Comparison Analysis",
};
